import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { vendorApi } from '../api/vendor.api';
import Loading from '../components/common/loading/Loading';
import VendorForm from '../components/vendors/VendorForm';
import { WrapInLayout } from '../layouts';

const VendorPage: FC = () => {
  let { idVendor } = useParams();
  const navigate = useNavigate();
  const { data: vendor } = vendorApi.useGetVendorQuery(idVendor || '', { skip: !idVendor });

  !idVendor && navigate('/vendors');
  return (
    <WrapInLayout title={`Vendor ${vendor?.name || ''}`} layout="portal">
      {!vendor
        ? <Loading />
        : <VendorForm vendor={vendor} />
      }
    </WrapInLayout>
  );
};

export default VendorPage;
